// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PbuY2","buttons":"styles_buttons__11OjC"};